import { createServerFn } from '@tanstack/react-start'
import { z } from 'zod'
import { requireSupabaseAuth } from '@/integrations/supabase/auth-middleware'

/**
 * Mallar som får skickas från inloggad app-kod. Alla andra mejl skickas från
 * sin egen server-route/serverfunktion — ingen generisk sändningsendpoint.
 */
const ALLOWED_TEMPLATES = ['welcome-signup', 'practice-abandonment'] as const

export const sendUserTemplateEmail = createServerFn({ method: 'POST' })
  .middleware([requireSupabaseAuth])
  .inputValidator((input) =>
    z
      .object({
        templateName: z.enum(ALLOWED_TEMPLATES),
        recipientEmail: z.string().trim().email().max(255),
        idempotencyKey: z.string().trim().max(200).optional(),
        templateData: z.record(z.string(), z.unknown()).optional(),
      })
      .parse(input),
  )
  .handler(async ({ data, context }) => {
    const recipient = data.recipientEmail.toLowerCase()
    const callerEmail = ((context.claims as any)?.email ?? '').toLowerCase()

    if (recipient !== callerEmail) {
      const { data: adminRow, error: roleErr } = await context.supabase
        .from('user_roles')
        .select('id')
        .eq('user_id', context.userId)
        .eq('role', 'admin')
        .maybeSingle()
      if (roleErr) throw new Error(roleErr.message)
      if (!adminRow) throw new Error('Forbidden')
    }

    const { supabaseAdmin } = await import('@/integrations/supabase/client.server')
    const { sendAndLogTemplateEmail } = await import('@/lib/email/send.server')

    const result = await sendAndLogTemplateEmail(supabaseAdmin, data.templateName, recipient, {
      templateData: data.templateData as Record<string, unknown> | undefined,
      idempotencyKey: data.idempotencyKey,
    })

    return result
  })
